import { isBefore, isEqual, parse } from 'date-fns'

const timeFormats = ['HH:mm', 'HH:mm:ss']

export const tryCompareTime = (
  time1: string,
  time2: string,
  format: string,
): boolean | undefined => {
  const today = new Date()
  try {
    const date1 = parse(time1, format, today)
    const date2 = parse(time2, format, today)

    if (date1.toString() === 'Invalid Date' || date2.toString() === 'Invalid Date')
      throw new Error('Invalid date')

    return isBefore(date1, date2) || isEqual(date1, date2)
  } catch (error) {
    return undefined
  }
}

export const isTimeAfterOrEqual = (time1: string, time2: string): boolean | undefined => {
  for (const timeFormat of timeFormats) {
    const res = tryCompareTime(time1, time2, timeFormat)

    if (res !== undefined) return res
  }
}
